import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name BackToTop
 */
export default class BackToTop extends Mixins(HybridMixin, Props) {
    scrollPosition: number = window.scrollY;

    /**
     * Add Button Position
     * 
     * @returns {object}
     */
    get buttonPosition() {
        if (this.getBoolean('right')) {
            return { right: '50px' };
        }
        return { left: '50px' };
    }

    /**
     * Scroll to the Element
     */
    scrollToTop() {
        if (this.getValue('scrollTo')) {
            const element = window.document.querySelector(this.getValue('scrollTo'));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(0, 0);
        }
    }

    /**
     * Do update scroll
     */
    updateScroll() {
        this.scrollPosition = window.scrollY;
    }

    /**
     * @inheritdoc
     */
    mounted() {
        window.addEventListener('scroll', this.updateScroll);
    }
}
